import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'loading-attribute-polyfill';
import 'intersection-observer';

import svg4everybody from 'svg4everybody';

svg4everybody();

/* Critical */
import './scripts/polyfill';
import './scripts/fonts';
import './scripts/header';
if (document.querySelector('.redirect-block')) {
    import('./scripts/redirect-block');
}
if (document.querySelector('.results-planner')) {
    import('./scripts/planner-results');
}
if (document.querySelector('.widget-family')) {
    import('./scripts/planner-recommendations');
}
if (document.querySelector('.collection')) {
    import('./scripts/planner-family');
}
import './scripts/recently-viewed';
if (document.querySelector('.widget-filter')) {
    import('./scripts/widget-filter');
}
import './lib/Select2';

/* Major */
// require('./scripts/cards');

if (
    document.querySelector('.js-favourite-toggle-job') ||
    document.querySelector('.js-favourite-toggle-course') ||
    document.querySelector('.js-favourite-toggle-content') ||
    document.querySelector('.js-favourite-toggle-jobgroup') ||
    document.querySelector('.js-favourite-toggle-content-list')
) {
    import('./scripts/favourites');
}
import './scripts/custom-site-search';
import './scripts/form';
if (document.querySelector('#map')) {
    import('./scripts/map-google');
}
import './scripts/sticky-messages';
if (document.querySelector('.sidebar')) {
    import('./scripts/content');
}

/* Minor */
if (
    document.querySelector('.details-block:not(.is-interests)') ||
    document.querySelector('.details-block.is-interests')
) {
    import('./scripts/details-block');
}
if (document.querySelector('.form-group-checkbox-multi')) {
    import('./scripts/multicheckbox');
}
if (
    document.querySelector('.is-sticky-xs') ||
    document.querySelector('.is-sticky-sm') ||
    document.querySelector('.is-sticky-md') ||
    document.querySelector('.is-sticky-lg')
) {
    import('./scripts/stickyfill');
}
import './scripts/pinned-nav';
import './scripts/animated-scroll';
import './scripts/lazy-load';
if (
    document.querySelector('.widget-family-match') ||
    document.querySelector('.widget-family-match-list')
) {
    import('./scripts/widget-family-match');
}

if (document.querySelector('[class^="planner-question"]')) {
    import('./scripts/planner-question');
}

if (document.querySelector('.form-group[data-dialog]')) {
    import('./scripts/dialog');
}

if (document.querySelector('.pill')) {
    import('./scripts/pills');
}

if (document.querySelector('#currentlyInEducation')) {
    import('./scripts/education-level-toggle');
}

if (document.querySelector('.registration-widget-email')) {
    import('./scripts/subscribe-toggle');
}

if (document.querySelector('.select2-container')) {
    import('./scripts/select2-anchor');
}

if (document.querySelector('.section-job-match-video')) {
    import('./scripts/video-resize');
}

if (document.querySelector('.section-job-details-actions.elSticky')) {
    import('./scripts/sticky-elements');
}

if (document.querySelector('.widget-list-footer')) {
    import('./scripts/widget-list');
}

if (document.querySelector('#feedbackForm')) {
    import('./scripts/widget-feedback');
}

if (document.querySelector('.question-container')) {
    import('./scripts/job-match-questions');
}

const urlPath = window.location.pathname;
const urlSegments = urlPath.split('/').filter(Boolean);

if (document.querySelector('#job-search')) {
    import('../ng/job-search');
}

if (document.querySelector('#job-search-v4')) {
    import('../ng/job-search-v4');
}

if (document.querySelector('#mini-job-search')) {
    import('../ng/hp-mini-search/job-search');
}

if (document.querySelector('#mini-course-search')) {
    import('../ng/hp-mini-search/course-search');
}

if (document.querySelector('.section-job-match-group-profiles')) {
    import('../ng/job-group-profiles');
}

if (
    document.querySelector('.widget-signup-container') ||
    document.querySelector('#job-details')
) {
    import('../ng/sign-ups');
}

// if they are prismic pages load the google Ads code
if (
    (urlSegments[0] === 'case-studies' && urlSegments.length > 1) ||
    (urlSegments[0] === 'job-profiles' && urlSegments.length > 1) ||
    document.querySelector('#pageBasicTitle')
) {
    import('../js/dpf').then(({ gTag }) => {
        gTag();
    });
}
/* Tracking */
import './scripts/tracking';

Modernizr.addTest('device-ios', function () {
    return navigator.userAgent.match(/(iPad|iPhone|iPod)/i);
});

Modernizr.addTest('meter', function () {
    return 'value' in document.createElement('meter');
});

if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
    document
        .querySelectorAll('svg.border-circle-cut')
        .forEach((e) => e.parentNode.removeChild(e));
}
